import {
  signInFormSchema,
  type SignInForm,
} from "@/schemas/user/signinFormSchema";
import { formOptions, revalidateLogic } from "@tanstack/react-form";

export const defaultValues: SignInForm = {
  id: null,
  pin: "",
};

export const signInFormOptions = formOptions({
  defaultValues,
  validators: {
    onSubmit: signInFormSchema,
  },
  validationLogic: revalidateLogic({
    mode: "submit",
    modeAfterSubmission: "change",
  }),
});
